

















import { Component, Prop, Vue } from "vue-property-decorator";
import Product from "@/components/shop/Product.vue";
import { Product as ProductType, CheckoutLineItem } from "shopify-buy";

@Component({ components: { Product } })
export default class Collection extends Vue {
  @Prop({ required: true }) addToCheckout!: (variantId: string, quantity: number) => void;
  @Prop({ required: true }) removeFromCheckout!: (variantId: string) => void;
  @Prop({ required: true }) lineItems!: typeof CheckoutLineItem[];
  @Prop({ required: true }) loading = false;
  @Prop({ required: true }) purchasedVariantIds!: string[];
  @Prop({ required: true }) products!: typeof ProductType[];

  get lineItemVariantIds() {
    return this.lineItems.map((item: typeof CheckoutLineItem) => item?.variant?.id);
  }

  decodedVariantId(product: typeof ProductType) {
    return atob(product.variants[0].id).replace("gid://shopify/ProductVariant/", "");
  }

  idInCheckout(id: string): boolean {
    return this.lineItemVariantIds.includes(id);
  }

  idIsPurchased(id: string): boolean {
    return this.purchasedVariantIds.includes(id);
  }
}
